import {Component, OnInit} from '@angular/core';
import {NotificationsService, ProjectService} from '@catcore/services';
import {Message} from '@catui/components/alert/types';
import {isNullOrUndefined} from 'util';

const URL = '/api/projects/from_upload';
const FormProperty = {
  WorkAuthorizationFile: 'globalConfigFile',
  FmcsConfigFile: 'fmcsConfigFile',
};

@Component({
  templateUrl: './global-project.component.html',
  styleUrls: ['./global-project.component.scss'],
})
export class GlobalProjectComponent implements OnInit {

  uploaderHandler = {
    uploadAll: (url: string) => {
      console.warn('upload not overwritten by implementation yet');
    },
  };

  uploadErrors: Message[];

  formData: FormData;
  globalConfigFiles: FileList;
  fmcsConfigFiles: FileList;

  get formIsValid() {
    let isValid = !isNullOrUndefined(this.formData);
    isValid = isValid && this.formData.has(FormProperty.WorkAuthorizationFile);
    return isValid;
  }

  constructor(private notificationService: NotificationsService,
              private projectService: ProjectService) {
  }

  ngOnInit() {
    this.formData = new FormData();
  }

  updateGlobalConfigFile(files: FileList) {
    this.globalConfigFiles = files;
    this.updateFormData(FormProperty.WorkAuthorizationFile, files);
  }

  updateFmcsConfigFile(files: FileList) {
    this.fmcsConfigFiles = files;
    this.updateFormData(FormProperty.FmcsConfigFile, files);
  }

  upload() {
    this.projectService
      .submitConfigFilesAsFormData(this.formData)
      .subscribe((result) => {
        this.notificationService.success(
          'Successful File upload',
          'All files where successfully uploaded',
        );
        this.projectService.refreshList();
      }, (error) => {
        console.error('upload failed', error);
        this.notificationService.error(
          'Error while uploading the files',
          error.error.default_error.detail,
        );

      })
    ;
  }

  private updateFormData(propertyName: string, files: FileList) {
    if (files.length > 0) {
      this.formData.append(propertyName, files[0]);
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project/components/global-project/global-project.component.ts